/**
 * Default fallback count when total inventory count is not available
 */
export const DEFAULT_VEHICLE_COUNT = 9000

/**
 * Generate default AI search placeholders with dynamic vehicle count
 * @param totalCount - Total inventory count (optional, defaults to DEFAULT_VEHICLE_COUNT)
 */
export const getDefaultSearchPlaceholders = (totalCount?: number): string[] => {
  const count = totalCount ?? DEFAULT_VEHICLE_COUNT
  const formattedCount = count.toLocaleString('en-GB')

  return [
    'VW Golf automatic up to 14K',
    'Cars under £200pm',
    "First car that's cheap to run",
    'Electric SUV Apple CarPlay',
    `Search ${formattedCount}${totalCount ? '' : '+'} used cars`,
  ]
}

/**
 * Static default placeholders
 */
export const DEFAULT_SEARCH_PLACEHOLDERS: string[] =
  getDefaultSearchPlaceholders()
